import { defineComponent as _defineComponent } from 'vue'


export type OptionItem = {
  label: string
  value: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownSelect',
  props: {
    label: null,
    options: null,
    selected: null
  },
  emits: ["update:selected"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:selected', items: number[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  label: string
  options: OptionItem[],
  selected: number[]
}





function handleChange(items: number[]) {
  emits('update:selected', items)
}

return { __sfc: true,props, emits, handleChange }
}

})